import { render, staticRenderFns } from "./Gem.vue?vue&type=template&id=459d8a44"
import script from "./Gem.vue?vue&type=script&lang=js"
export * from "./Gem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports